import Api from 'src/api/Base'

class PatchAdminConfigMessages extends Api {
  requestUrl = `/api/adminConfig`

  method = 'PATCH'
}

export default PatchAdminConfigMessages
